import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { usePurchaseAgreementsTFunction } from '@retail/purchase-agreements/i18n';
import { PriceTimeVariant } from '@retail/purchase-agreements/types';

interface Props {
  checkedPriceType: PriceTimeVariant;
  handleCheckPriceType: (variant: PriceTimeVariant) => void;
}

export function PricesToViewRadioSelect({ checkedPriceType, handleCheckPriceType }: Props) {
  const t = usePurchaseAgreementsTFunction();
  return (
    <FormControl>
      <FormLabel>
        <Typography variant="body2">{t('purchaseAgreements.priceList.pricesToShow')}:</Typography>
      </FormLabel>
      <RadioGroup sx={{ pl: 1 }}>
        <FormControlLabel
          control={
            <Radio
              checked={checkedPriceType === 'CURRENT'}
              onClick={() => handleCheckPriceType('CURRENT')}
            />
          }
          label={
            <Typography variant="subtitle2">
              {t('purchaseAgreements.priceList.currentPrices')}
            </Typography>
          }
        />
        <FormControlLabel
          control={
            <Radio
              checked={checkedPriceType === 'FUTURE'}
              onClick={() => handleCheckPriceType('FUTURE')}
            />
          }
          label={
            <Typography variant="subtitle2">
              {t('purchaseAgreements.priceList.futurePrices')}
            </Typography>
          }
        />
        <FormControlLabel
          control={
            <Radio
              checked={checkedPriceType === 'EXPIRED'}
              onClick={() => handleCheckPriceType('EXPIRED')}
            />
          }
          label={
            <Typography variant="subtitle2">
              {t('purchaseAgreements.priceList.expiredPrices')}
            </Typography>
          }
        />
      </RadioGroup>
    </FormControl>
  );
}
